// @ts-nocheck
import { AUTH_TOKEN, MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import axios from '../../common/interceptor/app.interceptor';
import appConfig from '../../config/config';
import { AUTHORIZATION_HEADER, MODULE_ID, SUMMARY_AUTHORIZATION_HEADER } from '../../home/common/constants/constants';
import {
  COMMON_API_HEADERS,
  PNQ_API_HEADERS,
  COMMON_PARAMS,
  DEDICATED_COMMON_PARAMS,
  LEAD_API_HEADERS,
  LEAD_API_HEADERS_DEV,
  AUTH_TOKEN_PLAN_PRICING,
  getProductType,
  isBulkUpgrade
} from '../constants/app.constants';
import { findParamFromUrl, getFromSessionStorage } from '../utils/app.utils';
import queryString from 'query-string';
import { SESSION_STORAGE } from 'home/view/upgrade-order/constants';

let utmParams = queryString.parse(window && window.location.search);
const utmParameter = {
  source: utmParams && utmParams.utm_source ? utmParams.utm_source : null,
  medium: utmParams && utmParams.utm_medium ? utmParams.utm_medium : null,
  campaign: utmParams && utmParams.utm_campaign ? utmParams.utm_campaign : null
};
export const APIConst = {
  profileUrl: `${appConfig.profileUrl}user/profile/v1/fetch/user/profile`,
  fetchLeadUrl: `${appConfig.apiBaseUrl}lead/fetch`,
  plansUrl: `${appConfig.apiBaseUrl}plans/fetch`,
  createLeadUrl: `${appConfig.apiBaseUrl}lead/create`,
  updateCustomerLeadUrl: `${appConfig.apiBaseUrl}lead/update`,
  submitSiebelLeadUrl: `${appConfig.apiBaseUrl}siebel/create/lead`,
  addDslConnectionDetailUrl: `${appConfig.apiBaseUrl}lead/add/dslConnectionDetails`,
  addDiConnectionDetailURL: `${appConfig.apiBaseUrl}lead/add/diConnectionDetails`,
  updateDslConnectionDetailUrl: `${appConfig.apiBaseUrl}lead/update/dslConnectionDetails`,
  checkOftFeasibilityUrl: `${appConfig.oftApiBaseUrl}feasibility/b2c/details`,
  checkOftFeasibilityDedicatedUrl: `${appConfig.dedicatedoftApiBaseUrl}feasibility`,
  sendOtpUrl: `${appConfig.otpApiBaseUrl}`,
  submitLeadUrl: `${appConfig.apiBaseUrl}lead/submit`,
  signOut: `${appConfig.signOut}pkmslogout?redirectURL=${appConfig.selfcareLoginPageUrl}`,
  createLeadAehUrl: `${appConfig.apiCallAEHUrl}lead/create`,
  cancelLeadUrl: `${appConfig.apiBaseUrl}lead/cancel`,
  fetchAllPlansAuthUrl: `${appConfig.apiCallAEHUrl}plans/fetch`,
  getCitiesUrl: `${appConfig.getCitiesUrl}/getCities`,
  oftCheckFeasibilityApi: `${appConfig.oftApiBaseUrl}feasibility/common-widget/check`,
  sendQuoteUrl: `${appConfig.apiBaseUrl}plans/sendQuote`,
  getLeadTokenUrl: `${appConfig.apiBaseUrl}login/aeh`,
  getSummaryLeadTokenUrl: `${appConfig.dedicatedSummaryAuthApiUrl}login/aeh`,
  needAssistanceUrl: `${appConfig.apiBaseUrl}lead/needAssistance`,
  getCommercialAttributesUrl: `${appConfig.apiBaseUrl}config/client/fetch`,
  submitClarity: `${appConfig.pnqapiBaseUrl}lead/doaSubmitClarity`,
  getClarityHistory: `${appConfig.pnqapiBaseUrl}lead/doaGetLifeCycle`,
  cancelOrder: `${appConfig.pnqapiBaseUrl}aehLead/cancelLead`,
  submitOrder: `${appConfig.pnqapiBaseUrl}lead/submit`,
  fetchPricing: `${appConfig.pnqapiBaseUrl}pricing`,
  getLeadByLeadId: `${appConfig.pnqLoginApiBaseUrl}aehLead/getLeads`,
  getRouter: `${appConfig.pnqapiBaseUrl}CPE`,
  getLeadPnqTokenUrl: `${appConfig.pnqapiBaseUrl}login/aeh`,
  sendProposalUrl: `${appConfig.apiBaseUrl}lead/sendQuotation`,
  getOrderConfirmationUsersUrl: `${appConfig.dedicatedSummaryApiUrl}order/getOrderConfirmationUsers`
};
export const fetchProfileData = (payload) => {
  return axios({
    method: 'get',
    url: APIConst.profileUrl
  });
};

export const getCities = () => {
  return axios({
    method: 'get',
    url: APIConst.getCitiesUrl,
    config: {
      ignoreError: true
    },
    skipServiceType: true
  });
};

export const fetchLead = (isdedicatedJourney) => {
  return axios({
    method: 'get',
    url: APIConst.fetchLeadUrl,
    // headers: COMMON_API_HEADERS,
    params: isdedicatedJourney ? DEDICATED_COMMON_PARAMS : COMMON_PARAMS,
    config: {
      ignoreError: false,
      dedicatedJourney: isdedicatedJourney
    }
  });
};

export const fetchAllPlans = (params, isdedicatedJourney, token) => {
  return axios({
    method: 'get',
    params: params,
    url: token ? APIConst.fetchAllPlansAuthUrl : APIConst.plansUrl,
    headers: COMMON_API_HEADERS,
    config: {
      ignoreError: false,
      dedicatedJourney: isdedicatedJourney,
      aehToken: token
    }
  });
};

export const addDslConnectionDetail = (payload) => {
  return axios({
    method: 'post',
    data: payload,
    url: APIConst.addDslConnectionDetailUrl,
    headers: COMMON_API_HEADERS,
    config: {
      ignoreError: false
    }
  });
};

export const addDiConnectionDetail = (payload) => {
  return axios({
    method: 'post',
    data: payload,
    url: APIConst.addDiConnectionDetailURL,
    headers: COMMON_API_HEADERS,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const updateDslConnectionDetail = (payload) => {
  return axios({
    method: 'post',
    data: payload,
    url: APIConst.updateDslConnectionDetailUrl,
    headers: COMMON_API_HEADERS,
    config: {
      ignoreError: false
    }
  });
};

export const createLeadHTTP = (payload, updateCustomer, isdedicatedJourney) => {
  const getPartyIdForDev = () => {
    if (isBulkUpgrade()) {
      return '25227908';
    }

    return '25222859';
  };

  let payLoad1 = payload;
  payLoad1.partyId = appConfig.env === 'DEV' ? getPartyIdForDev() : payload.partyId; // fo dev
  payLoad1.sendToCbft = true;
  if (utmParameter && (utmParameter.source || utmParameter.medium || utmParameter.campaign)) {
    payLoad1.utm = utmParameter;
  }
  return axios({
    method: 'post',
    url: updateCustomer ? APIConst.updateCustomerLeadUrl : APIConst.createLeadUrl,
    data: payLoad1,
    params: isdedicatedJourney ? DEDICATED_COMMON_PARAMS : COMMON_PARAMS,
    headers: appConfig.env === 'DEV' ? LEAD_API_HEADERS_DEV : COMMON_API_HEADERS,
    config: {
      ignoreError: false,
      dedicatedJourney: isdedicatedJourney
    }
  });
};
export const createLeadforAuth = (headers, isdedicatedJourney, payload) => {
  return axios({
    method: 'post',
    data: payload,
    url: APIConst.createLeadAehUrl,
    params: isdedicatedJourney ? DEDICATED_COMMON_PARAMS : COMMON_PARAMS,
    headers: appConfig.env === 'DEV' ? LEAD_API_HEADERS_DEV : LEAD_API_HEADERS,
    config: {
      aehToken: headers,
      ignoreError: false,
      dedicatedJourney: isdedicatedJourney
    }
  });
};
export const submitTalkToEpert = (payload, isdedicatedJourney) => {
  return axios({
    method: 'post',
    url: APIConst.createLeadUrl,
    data: payload,
    params: isdedicatedJourney ? DEDICATED_COMMON_PARAMS : COMMON_PARAMS,
    // headers: COMMON_API_HEADERS,
    config: {
      ignoreError: false,
      dedicatedJourney: isdedicatedJourney
    }
  });
};
export const submitSiebelLead = (isdedicatedJourney, auth_token = null) => {
  const getSiebelAxiosReq = () => {
    const baseReq = {
      method: 'post',
      url: APIConst.submitSiebelLeadUrl,
      // headers: COMMON_API_HEADERS,
      params: isdedicatedJourney ? DEDICATED_COMMON_PARAMS : COMMON_PARAMS,
      config: {
        ignoreError: false,
        dedicatedJourney: isdedicatedJourney
      }
    };

    if (auth_token) {
      return {
        ...baseReq,
        headers: {
          Authorization: auth_token
        }
      };
    }

    return baseReq;
  };

  return axios(getSiebelAxiosReq());
};

export const signOut = (payload) => {
  return axios({
    method: 'get',
    url: APIConst.signOut,
    config: {
      ignoreError: false
    }
  });
};
export const checkOftFeasibility = (payload) => {
  return axios({
    method: 'POST',
    data: payload,
    url: APIConst.checkOftFeasibilityUrl,
    headers: {
      'Content-Type': 'application/json'
    },
    config: {
      ignoreError: false
    }
  });
};

export const createNewFeasibilityFromId = (payload, isReuse) => {
  return axios({
    method: 'POST',
    data: payload,
    url: `${APIConst.checkOftFeasibilityDedicatedUrl}/recommended/create/response`,
    headers: {
      'Content-Type': 'application/json',
      feature: isReuse ? 'RE_USE_FEASIBILITY' : ''
    },
    config: {
      ignoreError: false
    }
  });
};

export const checkOftFeasibilityDedicated = (payload, isAddFeasibility, isReuse) => {
  return axios({
    method: 'GET',
    params: payload,
    url: isAddFeasibility ? `${APIConst.checkOftFeasibilityDedicatedUrl}/response` : `${APIConst.checkOftFeasibilityDedicatedUrl}?source=B2B`,
    headers: {
      'Content-Type': 'application/json',
      feature: isReuse ? 'RE_USE_FEASIBILITY' : '',
      accessToken: localStorage?.getItem('accessToken')
    },
    skipServiceType: true,
    config: {
      ignoreError: isAddFeasibility ? true : false
    }
  });
};

export const submitlead = (isdedicatedJourney) => {
  return axios({
    method: 'post',
    url: APIConst.submitLeadUrl,
    config: {
      ignoreError: false,
      dedicatedJourney: isdedicatedJourney
    }
  });
};

export const sendOtp = (payload) => {
  return axios({
    method: 'GET',
    url: APIConst.sendOtpUrl + '&scope=mc_mnv_validate+phone&state=state&nonce=nonce&login_hint=91' + payload + '&acr_values=2',
    headers: {
      'Content-Type': 'application/json'
    },
    config: {
      ignoreError: false
    }
  });
};

export const sendQuote = (payload) => {
  return axios({
    method: 'POST',
    data: payload,
    url: APIConst.sendQuoteUrl,
    headers: {
      'Content-Type': 'application/json'
    },
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};
export const getLeadToken = (payload, orderId) => {
  const isOrderSummaryPage = !!orderId;
  const leadAPIUri = isOrderSummaryPage ? APIConst.getSummaryLeadTokenUrl : APIConst.getLeadTokenUrl;

  return axios({
    method: 'POST',
    data: payload,
    url: payload && payload.pnqToken ? APIConst.getLeadPnqTokenUrl : leadAPIUri,
    headers: {
      'Content-Type': 'application/json'
    },
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};
export const needAssistance = (payload, isMultiSite) => {
  const headers = {
    'Content-Type': 'application/json'
  };
  if (isMultiSite) {
    headers['Authorization'] = getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
  }
  return axios({
    method: 'POST',
    data: payload,
    url: APIConst.needAssistanceUrl,
    headers,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};
export const submitclarity = (payload, token) => {
  return axios({
    method: 'post',
    url: APIConst.submitClarity,
    data: payload,
    ignoreMobileApp: false,
    headers: {
      'Content-Type': 'application/json'
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      pnqToken: token
    }
  });
};
export const getHistory = (params) => {
  return axios({
    method: 'get',
    url: APIConst.getClarityHistory,
    params: params,
    ignoreMobileApp: false,
    headers: {
      'Content-Type': 'application/json'
    },
    skipServiceType: true,
    config: {
      ignoreError: false
    }
  });
};
export const fetchPricing = (params, token) => {
  return axios({
    method: 'get',
    url: APIConst.fetchPricing,
    params: params,
    ignoreMobileApp: false,
    headers: {
      'Content-Type': 'application/json'
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      pnqToken: token
    }
  });
};

export const getLeadByLeadId = (params, token) => {
  return axios({
    method: 'get',
    url: APIConst.getLeadByLeadId,
    params: params,
    headers: PNQ_API_HEADERS,
    ignoreMobileApp: false,
    skipServiceType: true,
    config: {
      ignoreError: false,
      aehToken: token
    }
  });
};

export const cancelOrder = (payLoad, token) => {
  return axios({
    method: 'post',
    url: APIConst.cancelOrder,
    data: payLoad,
    headers: {
      'Content-Type': 'application/json'
    },
    ignoreMobileApp: false,
    skipServiceType: true,
    config: {
      ignoreError: false,
      pnqToken: token
    }
  });
};

export const submitOrder = (payLoad, token) => {
  return axios({
    method: 'post',
    url: APIConst.submitOrder,
    data: payLoad,
    headers: {
      'Content-Type': 'application/json'
    },
    ignoreMobileApp: false,
    skipServiceType: true,
    config: {
      ignoreError: false,
      pnqToken: token
    }
  });
};

export const getRouterDetails = (params = { segment: 'ENTERPRISE', product: getProductType() }) => {
  return axios({
    method: 'get',
    url: APIConst.getRouter,
    ignoreMobileApp: false,
    params,
    headers: {
      'Content-Type': 'application/json'
    },
    skipServiceType: true,
    config: {
      ignoreError: false
    }
  });
};
export const getCommercialAttributes = (payload) => {
  return axios({
    method: 'get',
    url: APIConst.getCommercialAttributesUrl,
    ignoreMobileApp: false,
    params: payload,
    headers: {
      'Content-Type': 'application/json'
    },
    skipServiceType: false,
    config: {
      ignoreError: false
    }
  });
};
export const createOrder = (payload) => {
  return axios({
    method: 'POST',
    url: appConfig.dedicatedSummaryApiUrl + 'order/create',
    data: payload,
    headers: COMMON_API_HEADERS,
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const fetchOrder = () => {
  return axios({
    method: 'get',
    url: appConfig.dedicatedSummaryApiUrl + 'order/fetch',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN)
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const getOrderConfirmationUsers = (isMultiSite) => {
  const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
  const singleSiteOrderToken = getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN);

  return axios({
    method: 'get',
    url: APIConst.getOrderConfirmationUsersUrl,
    headers: {
      'Content-Type': 'application/json',
      Authorization: isMultiSite ? orderAuthToken : singleSiteOrderToken
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const summaryAuthToken = (payLoad) => {
  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryAuthApiUrl + 'login/aeh',
    data: payLoad,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};
export const fetchExistingAddress = (payload) => {
  return axios({
    method: 'get',
    url: appConfig.dedicatedSummaryApiUrl + 'customer/contactDetails',
    params: payload,
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const fetchGSTDetail = (gstNumber) => {
  return axios({
    method: 'get',
    url: appConfig.dedicatedSummaryApiUrl + 'gst/getDetail',
    params: { gstNumber },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const cancelOrderForSummary = (remarks, isMultiSite = false) => {
  const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryApiUrl + 'order/cancel',
    data: { remarks },
    headers: {
      'Content-Type': 'application/json',
      Authorization: isMultiSite ? orderAuthToken : getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const submitOrderForSummary = () => {
  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryApiUrl + 'order/submit',
    data: {},
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN)
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const updateOrderForSummary = (payload) => {
  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryApiUrl + 'order/update',
    data: payload,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN)
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const validateOrderAsync = (params) => {
  return axios({
    method: 'GET',
    url: appConfig.dedicatedSummaryApiUrl + 'order/validate/orderDetails',
    params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN)
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const sendOTPForSummary = (params, isMultiSite) => {
  const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
  const singleSiteOrderToken =
    getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) ||
    getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN) ||
    findParamFromUrl('auth', false) ||
    orderAuthToken;

  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryApiUrl + 'otp/v2/send',
    params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: isMultiSite ? orderAuthToken : singleSiteOrderToken
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const verifyOTPForSummary = (payLoad, isMultiSite) => {
  const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
  const singleSiteOrderToken =
    getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) ||
    getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN) ||
    findParamFromUrl('auth', false) ||
    orderAuthToken;

  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryApiUrl + 'otp/v2/verify',
    data: payLoad,
    headers: {
      'Content-Type': 'application/json',
      Authorization: isMultiSite ? orderAuthToken : singleSiteOrderToken
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const uploadDocumentsForSummary = (payload, onUploadProgress) => {
  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryApiUrl + 'order/documents/upload',
    data: payload,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    onUploadProgress,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const deleteDocumentsForSummary = (payload) => {
  return axios({
    method: 'delete',
    url: appConfig.dedicatedSummaryApiUrl + 'order/documents/delete',
    params: payload,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const getUploadedDocumentsForSummary = (payload) => {
  return axios({
    method: 'GET',
    url: appConfig.dedicatedSummaryApiUrl + 'order/documents/fetch',
    params: payload,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    responseType: 'arraybuffer',
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};
export const fetchCityStateList = (pincode, productName = {}) => {
  const url = `${appConfig.kycApiBaseUrl}pincodeMaster`;
  return axios({
    method: 'GET',
    url: url,
    params: {
      ...productName,
      pincode: pincode
    },
    config: {
      ignoreError: true,
      dedicatedJourney: true
    },
    skipServiceType: true
  });
};

// for QA
// export const fetchCityStateList = (pincode) => {
//   const url = `http://10.5.245.150:8001/b2b-kyc/pincodeMaster`;
//   return axios({
//     method: 'GET',
//     url: url,
//     params: { pincode },
//     config: {
//       ignoreError: true,
//       dedicatedJourney: true
//     },
//     skipServiceType: true
//   });
// };

export const cancelLead = (payLoad, isdedicatedJourney) => {
  return axios({
    method: 'post',
    url: APIConst.cancelLeadUrl,
    data: payLoad,
    config: {
      ignoreError: false,
      dedicatedJourney: isdedicatedJourney
    }
  });
};

export const validateGstNumber = (gstNumber) => {
  const kyc_token_shifting = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN);

  return axios({
    method: 'GET',
    url: appConfig.dedicatedSummaryApiUrl + 'order/validate/gst',
    params: { gstNumber },
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || kyc_token_shifting
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};
export const sendProposal = (paylod, isdedicatedJourney) => {
  return axios({
    method: 'post',
    url: APIConst.sendProposalUrl,
    data: paylod,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
    //skipServiceType: true,
  });
};

// add reviewers feature
// export const sendEmailForOrderAuthentication = (recipientEmail, reviewerEmails, isMultiSite = false) => {
export const sendEmailForOrderAuthentication = (recipientEmails, isMultiSite = false) => {
  const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
  const singleSiteOrderToken =
    getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN) || orderAuthToken;

  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryApiUrl + 'order/sendConfirmationLink',
    data: { recipientEmails },
    headers: {
      'Content-Type': 'application/json',
      Authorization: isMultiSite ? orderAuthToken : singleSiteOrderToken
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const validateTokenForOrder = (token, type, orderId) => {
  return axios({
    method: 'post',
    url: appConfig.dedicatedSummaryApiUrl + 'auth/verifyToken',
    data: { token, type, orderId },
    headers: {
      'Content-Type': 'application/json'
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const fetch_BA_Accounts = (partyId) => {
  return axios({
    method: 'GET',
    url: appConfig.dedicatedSummaryApiUrl + 'customer/accounts',
    params: { partyId, billableOnly: false, product: getProductType() },
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const fetchAccountDetailsByAccountNumber = (bcpId) => {
  return axios({
    method: 'GET',
    url: appConfig.dedicatedSummaryApiUrl + 'customer/bcpDetails',
    params: { bcpId },
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const fetchBCPs = (accountNumber) => {
  return axios({
    method: 'GET',
    url: appConfig.dedicatedSummaryApiUrl + `customer/accounts/${accountNumber}`,
    // params: { accountNumber },
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const getOffers = (params) => {
  return axios({
    params: params,
    method: 'get',
    url: `${appConfig.baseAssetsUrl}otheroffer.json`,
    config: {
      ignoreError: true
    },
    skipServiceType: true
  });
};
export const loginSendOtp = (data) => {
  return axios({
    method: 'post',
    url: `${appConfig.ovapiBaseUrl}/otp/send`,
    data,
    config: {
      ignoreError: true
    },
    headers: {
      'Content-Type': 'application/json',
    }
  });
};

export const VerifyOtp = (data, params) => {
  return axios({
    method: 'post',
    url: `${appConfig.ovapiBaseUrl}/otp/verify`,
    data,
    params,
    config: {
      ignoreError: true
    },
    headers: {
      'Content-Type': 'application/json',
    }
  });
};
